export enum StampType {
	recipe = 'recipe',
	meal = 'meal',
}